module.exports = __webpack_public_path__ + "static/media/container.84690924.svg";